module.exports = __webpack_public_path__ + "static/media/gamesPlayed_100_250.4d117c7d.png";